/*
  FND-77 — SC 2.1.1. Three containers turn into horizontal scrollers under a
  media query (`wi-roice__cards`, `sustainable-values__grid`, and the PDP
  `hero-main-image`). A scroller that is not focusable can be dragged with a
  mouse or a finger but cannot be moved at all from a keyboard, so part of the
  content is unreachable without a pointer.

  `tabindex` is applied only while the element actually overflows, and removed
  when it stops. A permanent `tabindex="0"` in the markup would put a nameless
  stop in the desktop tab order where there is nothing to scroll.

  No role and no label: this is a plain scroll container, and the elements
  inside it carry their own semantics. Adding `role="region"` would announce a
  landmark that is not one.

  Never found before this point because every earlier axe run was desktop-only,
  where none of these three scrolls.
*/
(function () {
  /*
    Only containers whose content is NOT otherwise reachable.

    `.ugc-sec__items` is deliberately absent even though it scrolls. Each of its
    cards holds a focusable play button, so tabbing through them already scrolls
    the row - measured, scrollLeft 0 -> 230 -> 460 -> 690 -> 920 -> 1002 with
    every focused control on screen. axe agrees: it flags a scrollable region
    only when nothing inside it can take focus, and it has never reported that
    row. Adding a tabindex here would buy nothing and cost a tab stop with no
    accessible name.
  */
  const SELECTORS = ['.wi-roice__cards', '.sustainable-values__grid', '.hero-main-image'];
  // Sub-pixel layout rounding makes scrollWidth exceed clientWidth by a hair on
  // elements that do not really scroll; 2px keeps those out of the tab order.
  const SLOP = 2;

  function sync() {
    for (const el of document.querySelectorAll(SELECTORS.join(','))) {
      const scrolls =
        el.scrollWidth - el.clientWidth > SLOP || el.scrollHeight - el.clientHeight > SLOP;

      // Only touch what this script owns, so a tabindex set by anything else survives.
      if (scrolls && !el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
        el.dataset.scrollFocusable = 'true';
      } else if (!scrolls && el.dataset.scrollFocusable === 'true') {
        el.removeAttribute('tabindex');
        delete el.dataset.scrollFocusable;
      }
    }
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  };

  const start = () => {
    sync();
    window.addEventListener('resize', schedule);
    // Images and web fonts land after load and change scrollWidth.
    window.addEventListener('load', schedule);
    // Theme-editor block edits re-render the section under the same selectors.
    document.addEventListener('shopify:section:load', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
